import get from "lodash/get";
import getIsSimulatedSource from "selectors/story/getIsSimulatedSource";

export default function sendErrorReport(error, context = {}) {
  if (!getIsSimulatedSource() && window.Sentry) {
    window.Sentry.captureException(error, {
      tags: context,
    });
  }
  if (DEVELOPMENT) {
    //eslint-disable-next-line no-console
    console.error(get(error, "detail.reason"));
  }
  throw error;
}
